import { BaseService } from "@myhealth-raccoon/services";
import { BookingUserProfileModel, BookingRequest, AutomedBookingRequestResponse, UmbracoClinicModel, BookingConfirmationRequest, AppointmentByHash, AutomedPaymentResult } from "./types";
import { authService } from "../auth";

class BookingService extends BaseService {
    constructor() {
        super('v1/site',import.meta.env.VITE_BP_API_URL);
    }

    get Authorization() {
        return authService.Authorization;
    }
    
    public async GetClinicUmbracoDetails(siteId: string | number) {
        return this.get<UmbracoClinicModel>(`${siteId}/booking/umbraco/details`)
    }

    public async GetDoctorsAtSite(siteId: string | number) {
        return this.get<BookingUserProfileModel[]>(`${siteId}/booking/users`)
    }

    public async GetDoctorDetails(siteId: string | number, erpUserId: string | number) {
        return this.get<BookingUserProfileModel>(`${siteId}/booking/user/${erpUserId}/details`)
    }

    public async CreateBooking(siteId: string | number, payload: BookingRequest) {
        return this.put<AutomedBookingRequestResponse>(`${siteId}/booking/create`, payload);
    }

    public async ConfirmBooking(siteId: string | number, appointmentId: string | number) {
        return this.put(`${siteId}/booking/confirm/${appointmentId}`, null);
    }

    public async CompleteBooking(siteId: string | number, appointmentId: string | number, request: BookingConfirmationRequest) {
        return this.put(`${siteId}/booking/complete/${appointmentId}`, request);
    }

    public async CancelBooking(siteId: string | number, appointmentId: string | number, isPendingCancel?: boolean) {
        return this.put(`${siteId}/booking/cancel/${appointmentId}`, isPendingCancel);
    }
    public async GetBookingByHash(siteId: string | number, hash: string) {
        return this.get<AppointmentByHash>(`${siteId}/booking/manage/hash?hash=${hash}`);
    }

    public async GetPaymentResult(siteId: string | number, sessionId: string, sst: string) {
        const query = new URLSearchParams({sessionId, sst});
        return this.get<AutomedPaymentResult>(`${siteId}/booking/payment_result?${query}`);
    }
}

export const bookingService = new BookingService();
export * from './types';
